import { Expose, Transform } from 'class-transformer';
import { SurveyTextareaFieldElement } from '@/models/survey-elements/textarea-field-element';
const TEXTFIELD_TYPES: Record<string, string> = {
  '1': 'text',
  '2': 'email',
  '3': 'number',
};
export class SurveyTextFieldElement extends SurveyTextareaFieldElement {
  @Expose()
  @Transform(({ value }) => {
    return TEXTFIELD_TYPES[value as keyof Record<string, string>];
  })
  type!: string;
}
